import { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import clsx from 'clsx';
import { ArrowUpRightIcon, ClipboardListIcon, Ellipsis, Grip } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/shadcn/ui/avatar';
import {auth} from '../../../../firebase';
import React, { useEffect, useState } from 'react';
import useFirebase from '@/hook/useFirebase';

type ItemsType = {
  id: UniqueIdentifier;
  businessId: number;
  title: string;
  contactNumber: string;
};

const photoCache: Record<number, string> = {};

const Items = ({ id, businessId, title, contactNumber }: ItemsType) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: id,
    data: {
      type: 'item',
    },
    resizeObserverConfig: {}
  });
  const { getPhotoImage } = useFirebase();
  const [photoURL, setPhotoURL] = useState<string>('');

  useEffect(() => {
    const fetchPhoto = async () => {
      try {
        const url = await getPhotoImage(businessId);
        if (typeof url === 'string') {
          photoCache[businessId] = url;
          setPhotoURL(url);
        }
      } catch (error) {
        console.error('Erro ao buscar foto:', error);
      }
    };

    fetchPhoto();
  }, []);

  if (isDragging) return null;

  return (
    <Link to={`/levantamento/${businessId}`} title="Ir para levantamento" className="block w-full">
      <div
        ref={setNodeRef}
        {...attributes}
        style={{
          transition,
          transform: transform ? transform.toString() : undefined,
          visibility: isDragging ? "hidden" : "visible",
        }}
        className={clsx(
          "w-full max-w-[250px] overflow-hidden px-4 py-4 bg-white shadow rounded-xl h-[100px] border border-transparent hover:border-gray-200 cursor-pointer flex"
        )}
      >
        <div className="flex items-start h-full w-full">
          {/* Avatar e Ícone */}
          <div className="flex flex-col gap-2 pr-2 mr-2 items-center justify-center">
            <Avatar className="h-6 w-6">
              <AvatarImage src={photoCache[businessId]} alt="@shadcn" />
              <AvatarFallback>CN</AvatarFallback>
            </Avatar>
            <button className="py-2 px-1 relative border-2 border-transparent rounded-full focus:outline-none focus:text-gray-500 transition duration-150 ease-in-out">
            </button>
          </div>
          
          {/* Informações do Negócio */}
          <div className="w-full flex flex-col">
            <div className="flex justify-between border-l border-indigo-50 px-2 items-baseline gap-4">
              <div>
                <div className="flex items-baseline gap-2 max-w-[120px] truncate">
                  {title}
                  <p className="text-xs font-light">#{businessId}</p>
                </div>
                <p className="mt-2 text-xs hidden sm:block">{contactNumber}</p>
              </div>
              <div className="h-full flex flex-col items-center gap-6">
                <button title="Mover" className="px-1 text-xs rounded-xl" {...listeners}>
                  <Grip size={16} color="#4b5563" />
                </button>
                <Link to={`/detalhe/${businessId}`} title="Configurar">
                  <Ellipsis size={16} color="#4b5569" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default Items;
